// extracted by css-extract-rspack-plugin
export default {"ticketBase":"F6gOPw","center":"L1UYwR","cover":"TyEwTD","noise":"SdOnUW","ticket":"cBraGV","original":"CrXpgB","border":"cj_7L_","inner":"zx_cyx","active":"u0svK_"};